<template>
  <i v-if="type === 'font-awesome'" class="fa" :class="`fa-${name}`" aria-hidden="true"></i>
</template>

<script>
import './font-awesome-4.7.0/css/font-awesome.min.css'

export default {
  name: 'KqIcon',
  props: {
    type: {
      type: String,
      default: 'font-awesome'
    },
    name: {
      type: String,
      default: 'font-awesome'
    }
  }
}
</script>
